<template>
  <button
    :disabled="disabled"
    :class="variant ? variant : 'standard'"
    class="flex justify-center align-center"
    :type="type ? type : 'button'"
    ref="button"
    :style="buttonWidth && loading ? 'min-width: ' + buttonWidth + 'px' : ''"
  >
    <slot v-if="!loading"></slot>
    <Loading v-else :dark="true"></Loading>
  </button>
</template>

<script>
  import Loading from './Loading.vue'
  export default {
    components: { Loading },
    name: 'Button',
    props: ['variant', 'loading', 'disabled', 'type'],
    data: () => ({
      animationRunning: false,
      buttonWidth: 0
    }),
    mounted() {
      this.buttonWidth = this.$refs.button.offsetWidth
    }
  }
</script>

<style scoped>
  button {
    white-space: nowrap;
    transition: all 0.15s ease;
    border: none;
    outline: none;
    cursor: pointer;
    font-family: inherit;
  }
  button:disabled {
    background-color: rgba(0, 0, 0, 0.07) !important;
    color: rgba(0, 0, 0, 0.3) !important;
    cursor: not-allowed;
  }
  .text {
    background: none;
    font-weight: 600;
    padding: 4px 6px;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
  }
  .text:hover:not(:disabled) {
    color: rgba(0, 0, 0, 0.85);
    background: rgba(0, 0, 0, 0.04);
  }
  .standard,
  .round {
    border-radius: 8px;
    height: 38px;
    font-size: 0.875rem;
    padding: 0 14px;
    background-color: rgba(0, 0, 0, 0.06);
    color: rgba(0, 0, 0, 0.75);
    font-weight: 500;
  }
  .standard:hover:not(:disabled) {
    background-color: rgba(0, 0, 0, 0.09);
    color: rgba(0, 0, 0, 0.9);
  }
  button.small {
    height: 32px;
    font-size: 0.8rem;
    padding: 0 10px;
  }
  .round {
    border-radius: 50%;
    min-width: 38px;
    height: 38px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .round.small {
    min-width: 32px;
    height: 32px;
  }
  button.primary:not(:disabled) {
    background-color: var(--primary) !important;
    color: white !important;
  }
  button.primary:not(:disabled):hover {
    background-color: var(--primary-dark) !important;
  }
  .smooth {
    border-radius: 8px;
    padding: 0 14px;
    height: 38px;
    font-size: 0.875rem;
    font-weight: 500;
    background-color: rgba(0, 0, 0, 0.06);
    color: rgba(0, 0, 0, 0.75);
  }
  .smooth:hover:not(:disabled) {
    background-color: rgba(0, 0, 0, 0.09);
    color: rgba(0, 0, 0, 0.9);
  }
  .smooth.error {
    background-color: rgba(186, 6, 24, 0.1);
    color: #ba0618;
  }
  .smooth.error:hover:not(:disabled) {
    background-color: #ba0618;
    color: white;
  }
  .smooth.primary:not(:disabled) {
    background-color: var(--primary) !important;
    color: white !important;
  }
  .smooth.primary:not(:disabled):hover {
    background-color: var(--primary-dark) !important;
  }
</style>
